import WinLoss from './WinLoss'

export default WinLoss